import { fetchError, fetchStart, fetchSuccess, postSuccess } from './Common';
import axios from './config';
import { GET_BOOKINGS, GET_ASSIGNED_OO } from '../../@jumbo/constants/ActionTypes';
import { getBookingsApi, getAssignedOOApi, getRequestsApi, editRequestsApi } from 'redux/apis/workbook';

export const getBookings = (filterOptions = {}) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getBookingsApi(filterOptions)
        .then(data => {
          dispatch({ type: GET_BOOKINGS, payload: data.data });
          dispatch(fetchSuccess());
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const getAssignedOO = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getAssignedOOApi()
        .then(data => {
          dispatch(fetchSuccess());
          dispatch({ type: GET_ASSIGNED_OO, payload: data.data });
          resolve(data);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
};

export const GET_REQUESTS = 'GET_REQUESTS';
export function getRequests(data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      getRequestsApi(data)
        .then(res => {
          dispatch(fetchSuccess());
          dispatch({ type: GET_REQUESTS, payload: res.data });
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
}

export function editRequests(id, data) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchStart());
      editRequestsApi(id, data)
        .then(res => {
          dispatch(postSuccess(`Request moved to ${data.status} section`));
          resolve(res);
        })
        .catch(error => {
          dispatch(fetchError('There was something issue in responding server'));
          reject(error);
        });
    });
  };
}
